define('collections/Podio.Collections.ChecklistContacts',['require','underscore','jquery','collections/Podio.Collections.Contacts','lib/Podio.Routes'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var ContactsCollection = require('collections/Podio.Collections.Contacts');
  var routes = require('lib/Podio.Routes');

  return ContactsCollection.extend({

    initialize: function(models, options) {
      this.contactsType = options.type;
      this.linkedAccountId = options.linkedAccountId;
      this.contactable = options.contactable;
      this.excludeSelf = options.excludeSelf || false;
      this.order = options.order || 'name';
      this.offset = 0;
      this.searchQuery = '';

      if (options.spaceId) {
        this.spaceId = options.spaceId;
      }
    },

    makeRequest: function(data) {
      var self = this;
      var dfd = new $.Deferred();

      // TODO clean up this method, since we don't want to do custom calls and handle errors ourselves
      var req = this.request('get', routes.index_for_checklist_path(), data, { abortable: true });

      req.done(_.bind(function(responseData) {
        if (responseData.status && responseData.status === 'error' && responseData.message) {
          dfd.reject();
          self.trigger('error', self, responseData);
          return true;
        }

        if (responseData.data.object.length) {
          this.reset(this.parse(responseData));
        }
        this.offset = this.offset + responseData.data.size;
        dfd.resolve(responseData);
      }, this));

      return dfd;
    },

    getContacts: function(searchKey) {
      if (searchKey) {
        this.searchQuery = searchKey;
      }

      switch (this.contactsType) {
      case 'podio':
        return this.getAllPodioMembers();
      case 'podioSpaceMembers':
        return this.getPodioSpaceMembers();
      case 'podioSpaceContacts':
        return this.getPodioSpaceContacts();
      default:
        return this.getLinkedAccountContactsForChecklist();
      }
    },

    getAllPodioMembers: function() {
      return this.getPodioContactsForChecklist({
        type: 'podio',
        use_user_ids: true,
        exclude_self: this.excludeSelf,
        order: this.order
      });
    },

    getPodioSpaceMembers: function() {
      return this.getPodioContactsForChecklist({
        'type': 'podio',
        'use_user_ids': true,
        'space_id': this.spaceId,
        'order': this.order
      });
    },

    getPodioSpaceContacts: function() {
      return this.getPodioContactsForChecklist({
        'type': 'podio',
        'contact_type': 'space',
        'use_user_ids': false,
        'space_id': this.spaceId,
        'order': this.order
      });
    },

    getPodioContactsForChecklist: function(data) {
      data['order'] = this.order;
      data['offset'] = this.offset;

      if (this.searchQuery) {
        data['search'] = this.searchQuery;
      }

      return this.makeRequest(data);
    },

    getLinkedAccountContactsForChecklist: function() {
      var data = {
        type: 'linked_account',
        id: this.linkedAccountId,
        offset: this.offset
      };

      if (this.searchQuery) {
        data['search'] = this.searchQuery;
      }

      if (this.contactable === true || this.contactable === false) {
        data['contactable'] = this.contactable.toString();
      }

      return this.makeRequest(data);
    }

  });

});

